import React from "react";
import '../Styling/templateBuilder.css';
import autoBind from 'react-autobind';

class RadioOptions extends React.Component{
	constructor(props){
		super(props);
		autoBind(this)
	}
	populateRadio(){
		var radio = document.getElementById(this.props.name);
		if (radio){
			radio.innerHTML = '';
			radio.onclick = function () {
				this.updateRadioValue();
			}.bind(this);
			for (var i = 0; i < this.props.options.length; i++){
				var button = document.createElement("input");
				button.type = "radio";
				button.name = this.props.name + "option";
				button.id = this.props.name + this.props.options[i] + "option";
				(this.props.options[i] === this.props.default) ? button.checked = true: button.checked = false;
				button.value = this.props.options[i];
				if (this.props.name === "intentRadio" && this.props.operations && !this.props.operations.includes(this.props.options[i])){
					button.disabled = true;
				}
				if (this.props.options[i] === "CreateOrUpdate" && (this.props.operations.includes("Create") && this.props.operations.includes("Update"))){
					button.disabled = false;
				}
				if (this.props.name === 'commitRadio' && this.props.intent === 'Retrieve'){
					button.disabled = true;
				}
				var label = document.createElement("label");
				label.className = "radio-button-selection";
				label.appendChild(button);
				label.appendChild(document.createTextNode(this.props.options[i]));
				radio.appendChild(label);
			}
		}

	}

	updateRadioValue(){
		var values = document.getElementsByName(this.props.name + "option");
		for (var i = 0; i < values.length; i++){
			if (values[i].checked){
				this.props.update(values[i].value);
				break;
			}
		}
	}

	componentDidMount(){
		this.populateRadio();
	}

	render() {
		this.populateRadio();
		return (
			<div id={this.props.name + "-radio"} className="radioOptions">
				<form id = {this.props.name} onClick={() => this.updateRadioValue()} style={{margin: '0'}}>
				</form>
			</div>
		);
	}

}

export default RadioOptions;